import React from "react";
import bannerImg from "../../assets/images/web-development-services.png";
import "../../styles/Webdevelopment.css";
import { Link } from "react-router-dom";

function Webbanner() {
  return (
    <div>
      <section className="webbanner">
        <div className="webbanner-content">
          {/* <div className="webbanner-tag">Web Development </div> */}
          <h1>
            Web Development Company in Noida for High-Performance Websites
          </h1>
          <p>
            In these days’s digital world, having a expert website is important
            for business increase. A properly-designed and completely practical
            internet site facilitates you attract clients. If you're searching
            for a dependable <b>Web Development Company in Noida</b>, you need a
            partner who is aware your enterprise goals and offers end
            result-pushed solutions.
          </p>
          <div className="webbanner-cta">
            <a href="./Contact" className="webbanner-btn primary">
              Get Free Consultation →
            </a>
          </div>
        </div>
        <div className="webbanner-image">
          <img
            src={bannerImg}
            width="400"
            height="300"
            alt="Web Development Solutions"
          />
        </div>
      </section>
      <div className="breadcrumb">
        <Link to="/">Home</Link>
        <span> / </span>
        <span>Web Development</span>
      </div>
    </div>
  );
}

export default Webbanner;
